// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"525927bd","239":"1e3de8dd","455":"d273adcb"}[chunkId] + ".chunk.js";
};